module.exports = __webpack_public_path__ + "img/card.6e1fca2b.png";